import type { ApolloError } from '@apollo/client'
import { GetRoleDocument, GetRoleQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type Role = NonNullable<GetRoleQuery['jobCatalog']['role']> & {
  policyTargetClass: string
}

type Return = [Role | undefined, boolean, () => void, ApolloError | undefined]

export const useRole = (id: string): Return => {
  const { data, loading, refetch, error } = useQuery(GetRoleDocument, {
    variables: { id },
  })

  const role = !loading
    ? ({
        ...data?.jobCatalog.role,
        policyTargetClass: '::JobCatalog::Role',
      } as Role)
    : undefined

  return [role, loading, refetch, error]
}
